import { notification } from 'src/components/Notification';

export const tryCall = (callback, defaultValue = null) => {
  let result = null;
  try {
    result = callback();
  } catch (e) {
    notification.error(e);
  }

  return result || defaultValue;
};
